<template>
  <!-- <a-drawer
    :closable="false"
    :title="title"
    :visible="visible"
    :width="width"
    @close="close"
    destroyOnClose
    placement="right"
  >
    <wf-dev-permission-list @ok="submitCallback" ref="realForm" :model="model"></wf-dev-permission-list>
  </a-drawer>-->

  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <wf-dev-permission-list :model="model" @ok="submitCallback" ref="realForm"></wf-dev-permission-list>
  </j-modal>
</template>

<script>

  import WfDevPermissionList from './WfDevPermissionList'

  export default {
    name: 'WfDevPermissionListModal',
    components: {
      WfDevPermissionList
    },
    data () {
      return {
        title: "操作",
        width: 1100,
        visible: false,
        disableSubmit: false,
        model: {},
      }
    },
    methods: {
      show (model) {
        this.model = model;
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
  .drawer-footer {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>